import { SideNavItemsMap } from './models/sideNavItemsMap';
import { SIDENAV_ITEMS_PUBLISHER } from './SIDENAV_ITEMS_PUBLISHER';
import { SIDENAV_ITEMS_DEVICE } from './SIDENAV_ITEMS_DEVICE';
import { SIDENAV_ITEMS } from './SIDENAV_ITEMS';
import { CTV_OPTIONS } from './REPORT_CONFIG';

export const SIDENAV_ITEMSMAPS: Array<SideNavItemsMap> = [
  {
    id: 'top-publisher',
    title: 'Publisher Rankings',
    summaryMainFilterItems: [
      {
        key: 'platformName',
        label: 'OS',
        selected: {
          label: '<i class="fa fa-android mr-1"></i> Google Play',
          value: 'android'
        },
        groups: ['app'],
        hidden: false,
        type: 'toggle-filter',
        options: [
          {
            label: '<i class="fa fa-android mr-1"></i> Google Play',
            value: 'android'
          },
          { label: '<i class="fa fa-apple mr-1"></i> App Store', value: 'ios' }
        ]
      },
      {
        key: 'platformName',
        label: 'OS',
        selected: CTV_OPTIONS[0],
        groups: ['ctv'],
        hidden: false,
        type: 'toggle-filter',
        options: [...CTV_OPTIONS]
      }
    ],
    sideNavItems: SIDENAV_ITEMS_PUBLISHER
  },
  {
    id: 'top-seller',
    title: 'Seller Rankings',
    summaryMainFilterItems: [],
    sideNavItems: SIDENAV_ITEMS
  },
  {
    id: 'top-device',
    title: 'IOT Device Rankings',
    groups: ['app', 'ctv'],
    summaryMainFilterItems: [
      {
        key: 'platformName',
        label: 'OS',
        selected: {
          label: '<i class="fa fa-android mr-1"></i> Google Play',
          value: 'android'
        },
        groups: ['app'],
        hidden: false,
        type: 'toggle-filter',
        options: [
          {
            label: '<i class="fa fa-android mr-1"></i> Google Play',
            value: 'android'
          },
          { label: '<i class="fa fa-apple mr-1"></i> App Store', value: 'ios' }
        ]
      }
    ],
    sideNavItems: SIDENAV_ITEMS_DEVICE
  }
];
